import type { RouteRecordRaw } from "vue-router"

// Lazy importing of the error views can break the application when chunks fail to load
//
// I plan to handle this better by adding PWA support but this should help us for now.
import GeneralErrorView from "@/views/error/GeneralErrorView.vue"

const routes: RouteRecordRaw[] = [
  {
    name: "error.general",
    path: "/error/general",
    component: GeneralErrorView,
    meta: {
      preventBack: true,
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "error.not-found",
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/NotFoundView.vue"),
    meta: {
      hideStepper: false,
    },
  },
  {
    name: "error.timeout",
    path: "/error/timeout",
    component: () => import("@/views/error/ExpiredSessionView.vue"),
    meta: {
      preventBack: true,
      public: true,
      hideStepper: true,
    },
  },
  {
    name: "error.unauthorized",
    path: "/error/unauthorized",
    component: GeneralErrorView,
    meta: {
      public: true,
      hideStepper: true,
    },
  },
]

export default routes
